import type { ReactNode } from 'react';

export type BadgeVariant = 'success' | 'accent' | 'warning' | 'neutral' | 'outline';

export interface BadgeProps {
  variant?: BadgeVariant;
  dot?: boolean;
  children: ReactNode;
  className?: string;
}

export function Badge({ variant = 'neutral', dot = false, children, className = '' }: BadgeProps) {
  const cls = ['tr-badge', `tr-badge--${variant}`, className].filter(Boolean).join(' ');
  return (
    <span className={cls}>
      {dot && <span className="tr-badge__dot" />}
      {children}
    </span>
  );
}
